import React from 'react';

import type { IIcon } from '../types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 30, className, onClick }, ref) {
  return (
    <svg ref={ref} viewBox='0 0 512 512' onClick={onClick} width={size} height={size} className={className}>
      <path fill='#E2E5E7' d='M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z' />
      <path fill='#B0B7BD' d='M384,128h96L352,0v96C352,113.6,366.4,128,384,128z' />
      <polygon fill='#CAD1D8' points='480,224 384,128 480,128 ' />
      <path fill='#E061A0' d='M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16V416z' />
      <g>
        <path
          fill='#FFFFFF'
          d='M57.4,383.1c-4,0-8.4-2.3-8.4-7.9v-72.7c0-4.6,4.4-7.9,8.4-7.9h27.8c55.5,0,54.3,88.5,1.1,88.5H57.4z M65,310.1v57.3h20.2c32.8,0,34.3-57.3,0-57.3H65z'
        />
        <path
          fill='#FFFFFF'
          d='M186,384.4c-22.5,1-45.8-14.7-45.8-46.1c0-31.5,23.3-46.9,45.8-46.9c21.3,1.1,43.5,16.6,43.5,46.9 C229.5,368.6,207.3,384.4,186,384.4z M184.7,308c-13.6,0-28.4,10.1-28.4,30.3c0,20.1,14.8,30.3,28.4,30.3c14,0,28.9-10.2,28.9-30.3 C213.6,318.1,198.6,308,184.7,308z'
        />
        <path
          fill='#FFFFFF'
          d='M243.8,338.2c0-24.7,14.7-45.9,42.7-45.9c10.6,0,19,3.3,27.8,11.4c3.3,3.2,3.6,8.8,0.4,12.4 c-3.3,3.1-8.3,2.7-11.2-0.4c-5-5.5-10.1-7-17-7c-18.7,0-27.7,14-27.7,29.6c0,15.9,8.9,30.4,27.7,30.4c6.9,0,13.4-3,19-8.2 c3.8-3.1,9-1.6,11.2,1.5c1.9,2.8,2.9,7.6-1.3,12c-8.5,8.3-18.7,10-28.8,10C257,384,243.8,362.8,243.8,338.2z'
        />
      </g>
      <path fill='#CAD1D8' d='M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z' />
      <path
        fill='#FFFFFF'
        d='M371.1,324l22.3-27.9c6.7-8.7,19.6,2.4,12.3,10.7c-7.7,9.1-15.7,18.9-23.4,29l26.1,32.5c7,9.6-7,18.8-13.9,9.3 l-23.7-30.1l-23.2,30.8c-6.5,9.3-21-1.2-13.7-9.9l25.7-32.6c-8.1-10.1-15.9-20-23.7-29c-8-9.6,6.9-19.4,12.8-10.5L371.1,324z'
      />
    </svg>
  );
});

export default React.memo(Icon);
